export default __webpack_public_path__ + "static/media/screenshot3.d817d0df.jpg";